module.exports = __webpack_public_path__ + "media/images/emblems/Poschiavo_wappen-d64f2959c7602c2531e43e294ba10040.svg";